import Factory from '@/utils/request'

const baseURL = process.env.VUE_APP_PRO_API

export default Factory(
  {
    baseURL
  },
  () => false
)

// 访问宣传网站接口
export const webFactory = Factory(
  {
    baseURL: '/easadmin-api'
  },
  () => false
)

